import "./case-title.sass";

type Props = {
  title: string;
};

const CaseTitle = ({ title }: Props) => {
  const match = title.match(/yoga day/i);

  if (!match || match.index === undefined) {
    return <div className="case-title">{title}</div>;
  }

  const splitIndex = match.index;
  const before = title.slice(0, splitIndex).trimEnd();
  const after = title.slice(splitIndex).trimStart();

  return (
    <div className="case-title">
      {before}
      <br />
      {after}
    </div>
  );
};

export default CaseTitle;
